export default __webpack_public_path__ + "static/media/loader.60d8774d.gif";